export enum RightPanelType {
    user = 1,
    ticket = 2,
    // odoo = 3,
    linkedTickets = 4,
    // servicenow = 5,
    ticketStatuses = 6,
    // editFields = 7,
    redactTicket = 8,
    voyado = 9,
    groupInfo = 10,
    hideTicketContent = 11,
}
